import { getApiErrorMessage } from "../../../../../utils/commonFunction";
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */

import React, { useEffect, useState } from "react";
import { fetchDepotDetail, fetchFranchiseDepotList, fetchFranchiseUsingDepot } from "../../../_redux/depots/deoptsActions";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import ActiveDialogApi from "../../../../../../_metronic/_partials/widgets/alert/ActiveDialogApiCall";
import { DepotDetailsEdit } from "../../franchises/franchise-canva";
import { LinkDepotToFranchiseCanvas } from "../depot-canvas/LinkDepotToFranchiseCanvas";
import NewBreadCrumbs from "../../../../../../_metronic/layout/components/subheader/components/NewBreadCrumbs";
import { NewDepotCanvas } from "../depot-canvas/NewDepotCanvas";
import SVG from "react-inlinesvg";
import SnackBarTool from "../../../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import { findFranchiseDepotStatus } from "../../../_redux/depots/depotsCrud";
import { initIds } from "../../../../../../_metronic/_partials/controls/RightPanel";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { useIntl } from "react-intl";
import { useParams } from "react-router";
import DepotPriceModal from "../depot-component/DepotPriceModal";

export function DepotDetails() {
    const intl = useIntl();
    const dispatch = useDispatch();
    const { id } = useParams();

    const init = ["kt_new_depot_panel", "kt_link_depot_to_franchise_panel", "kt_depotdetailsedit_panel1"];

    useEffect(() => {
        initIds(init);
    }, [init]);

    const [snack, setSnack] = useState({ call: false, type: "", message: "" });
    const [dialog, setDialog] = useState({ modal: false });
    const [dialogDepot, setDialogDepot] = useState({ modal: false });

    const { detailData, franchiseOnDepot, depot_prices, permission } = useSelector(
        (state) => ({
            detailData: state.depot.detail,
            franchiseOnDepot: state.depot.franchiseUsingDepot,
            depot_prices: state.depot.detail.depot_prices,
            permission: state.auth.permission,
        }),
        shallowEqual
    );

    useEffect(() => {
        dispatch(fetchDepotDetail(id));
        dispatch(fetchFranchiseUsingDepot(id));
        dispatch(fetchFranchiseDepotList(id));
    }, [dispatch, id]);

    const getDay = (day) => {
        switch (day) {
            case 1:
                return intl.formatMessage({ id: "Monday" });
            case 2:
                return intl.formatMessage({ id: "Tuesday" });
            case 3:
                return intl.formatMessage({ id: "Wednesday" });
            case 4:
                return intl.formatMessage({ id: "Thursday" });
            case 5:
                return intl.formatMessage({ id: "Friday" });
            case 6:
                return intl.formatMessage({ id: "Saturday" });
            case 7:
                return intl.formatMessage({ id: "Sunday" });

            default:
                return "";
        }
    };

    const handleUpdateStatus = () => {
        setSnack({ call: false, type: "", message: "" });
        const data = {
            id: dialog.data.id,
            status: dialog.data.e ? 1 : 0,
        };
        findFranchiseDepotStatus(data)
            .then((res) => {
                dispatch(fetchFranchiseUsingDepot(id));
                setSnack({ call: true, type: "success", message: res.data.message });
            })
            .catch((error) => {
                setSnack({
                    call: true,
                    type: "error",
                    message: getApiErrorMessage(error),
                });
            });
        setDialog({ modal: false });
    };

    const DepotPrices = ({ prices }) => {
        if (!prices || prices.length === 0) {
            return <p className="text-gray-500">No pricing data available</p>;
        }
        return (
            <>
                <div className="mb-5">
                    <strong> Stairstep pricing breakdown</strong>
                    {depot_prices && depot_prices.length > 0 ? (
                        <span className="svg-icon svg-icon-sm svg-icon-primary ml-3" onClick={() => setDialogDepot({ modal: true })} style={{ cursor: "pointer" }}>
                            <SVG style={{ color: "orange" }} title="edit" className="h-22 align-self-end" src={toAbsoluteUrl("/media/svg/icons/Design/Edit.svg")}></SVG>
                        </span>
                    ) : null}
                </div>

                <div className="bg-white rounded-xl shadow-md">
                    <div className="overflow-x-auto">
                        <table className="min-w-full border border-gray-200 rounded-lg">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-6 py-3 text-left text-sm font-medium text-gray-600 border-b">Pod (Units)</th>
                                    <th className="px-6 py-3 text-left text-sm font-medium text-gray-600 border-b">Price per Unit (&pound;/mo)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {prices.map((item, index) => (
                                    <tr key={index} className="hover:bg-gray-50 transition-colors duration-150">
                                        <td className="px-6 py-3 text-gray-800 border-b">{item.tier_end_unit || `${index + 1}+`}</td>
                                        <td className="px-6 py-3 text-gray-800 font-medium border-b">&pound;{Number(item.unit_amount).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            {/* NewDepotCanvas component */}
            <NewDepotCanvas title={intl.formatMessage({ id: "Edit.Depot.Details" })} />
            {/* LinkDepotToFranchiseCanvas component */}
            <LinkDepotToFranchiseCanvas title={intl.formatMessage({ id: "Add.Franchise" })} depotId={detailData} />
            {/* NewBreadCrumbs component */}
            <NewBreadCrumbs title={intl.formatMessage({ id: "Depot.Details" })} />
            <div className="row">
                <div className="col-lg-12 col-xl-12 col-md-12">
                    <div className="card card-custom  gutter-b mb-10">
                        <div className="card-body">
                            <div className="d-flex  w-100 mb-10">
                                <div className="mt-4 font-weight-bolder font-size-h5 text-dark-75 text-hover-primary ">
                                    <h3 className="card-title align-items-start flex-column d-flex">
                                        <span className="font-weight-bolder text-dark">{detailData?.name}</span>
                                        <span className={`text-${detailData?.status === 1 ? "success" : "danger"} font-weight-bold font-size-sm mt-3`}>{detailData?.status === 1 ? "Active" : "Inactive"}</span>
                                    </h3>
                                </div>
                                <div className="mt-2">
                                    <span className="symbol-label ml-2 pointer">
                                        {permission?.setting_depot?.edit ? (
                                            <button className="btn btn-link" id="kt_depotdetailsedit_panel1_toggle">
                                                <span className="svg-icon svg-icon-sm svg-icon-primary">
                                                    <SVG className="h-25 align-self-end" title="Edit" src={toAbsoluteUrl("/media/svg/icons/Design/Edit.svg")}></SVG>
                                                </span>
                                            </button>
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 mb-5">
                                    <div>
                                        <strong>{intl.formatMessage({ id: "Depot.Short" })}</strong>{" "}
                                    </div>
                                    <div className="text-muted">{detailData?.short_name}</div>
                                </div>
                                <div className="col-md-3 mb-5">
                                    <div>
                                        <strong>{intl.formatMessage({ id: "Depot.ID" })}</strong>{" "}
                                    </div>
                                    <div className="text-muted">{detailData.depot_reference_id}</div>
                                </div>
                                <div className="col-md-5 mb-5">
                                    <div>
                                        <strong>{intl.formatMessage({ id: "Depot.Manager" })}</strong>{" "}
                                    </div>
                                    <div className="text-muted">{detailData?.manager_name}</div>
                                </div>

                                <div className="col-md-7 mb-5">
                                    <div>
                                        <strong> {intl.formatMessage({ id: "Address" })}</strong>{" "}
                                    </div>
                                    <div className="text-muted">
                                        {detailData?.address_line_1}
                                        <br></br>
                                        {detailData && detailData.address_line_2 ? (
                                            <>
                                                {detailData.address_line_2}

                                                <br></br>
                                            </>
                                        ) : (
                                            ""
                                        )}
                                        {detailData && detailData.address_line_3 ? (
                                            <>
                                                {detailData.address_line_3}

                                                <br></br>
                                            </>
                                        ) : (
                                            ""
                                        )}
                                        {detailData?.city}
                                        <br></br>
                                        {detailData?.postcode}
                                    </div>
                                </div>
                                <div className="col-md-5 mb-5">
                                    <div className="mb-5">
                                        <div>
                                            <strong>{intl.formatMessage({ id: "PHONE" })}</strong>{" "}
                                        </div>
                                        <div className="text-muted">{detailData?.phone}</div>
                                    </div>
                                    <div className="mb-5">
                                        <div>
                                            <strong>{intl.formatMessage({ id: "EMAIL" })}</strong>{" "}
                                        </div>
                                        <div className="text-muted">{detailData?.manager_email}</div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="row text-muted">
                                    <div className="col-md-6 border rounded-lg shadow-sm p-4 m-3 bg-white">
                                        <div className="mb-5">
                                            <strong>{intl.formatMessage({ id: "Opening.Hours" })}</strong>
                                        </div>
                                        {detailData &&
                                            detailData.depot_hours &&
                                            detailData.depot_hours.map((data, index) => (
                                                <div className="row mb-5  " key={index}>
                                                    <div className="col">{getDay(data?.day)}</div>
                                                    <div className="col">
                                                        {data.open_time === "00:00" ? "Closed" : data.open_time} - {data.close_time === "00:00" ? "Closed" : data.close_time}
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                    <div className="col-md-5 border rounded-lg shadow-sm p-4 m-3 bg-white">
                                        <DepotPrices prices={depot_prices} />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="d-flex justify-content-between align-items-center mb-5 mt-10">
                                    <div>
                                        <strong>{intl.formatMessage({ id: "Franchise.Using.Depot" })}</strong>
                                    </div>

                                    <div>
                                        <button id="kt_link_depot_to_franchise_panel_toggle" className="btn btn-primary btn-sm font-weight-bold">
                                            {intl.formatMessage({ id: "Add.Franchise" })}
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 text-muted border rounded-lg shadow-sm p-4 m-3 bg-white">
                                        {franchiseOnDepot &&
                                            franchiseOnDepot.map((data, index) => (
                                                <div className="row mb-5 d-flex align-items-center " key={index}>
                                                    <div className="col">{data.franchise_data.name}</div>
                                                    <div className="col">
                                                        <div className="d-flex align-items-center">
                                                            <div> </div>
                                                            <div>
                                                                <span className="switch switch-outline switch-icon switch-primary">
                                                                    <label>
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={data?.status === 1 ? true : false}
                                                                            name="franchise_using_depot"
                                                                            onChange={(e) =>
                                                                                setDialog({
                                                                                    status: data.status,
                                                                                    modal: true,
                                                                                    data: {
                                                                                        e: e.target.checked,
                                                                                        id: data.id,
                                                                                    },
                                                                                })
                                                                            }
                                                                        />
                                                                        <span></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                    <div className="col-md-6"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="col-lg-12 col-xl-6">
          <Metrics filterBtn="false" noOfChart="false" />
        </div> */}
            </div>
            {/* <ActiveDialogApi
        dialog={dialog}
        setDialog={setDialog}
        handleChange={handleUpdateStatus}
      /> */}
            {depot_prices && <DepotPriceModal dialog={dialogDepot} setDialog={setDialogDepot} editedPrices={depot_prices} depot_id={detailData.id} setSnack={setSnack} />}
            {snack.call ? <SnackBarTool {...snack} /> : ""}
            <DepotDetailsEdit type={"1"} data={detailData ? detailData : ""} check={"depot"} />
        </>
    );
}
